'use strict';

var formValidation = require('../components/formValidation');
var clientSideValidation = require('../components/clientSideValidation');
var address = require('../checkout/address');
var klaviyoIdentify = require('../klaviyoIdentify');

function selectSignIn() {
    $('#createaccountModal .signin-link').on('click', function () {
        $('#createaccountModal').modal('hide');

        setTimeout(function () {
            $('.signin-modal')[0].click();
        }, 400);
    });
}

function selectCreateAccount() {
    $('#signinModal .create-account-link').on('click', function () {
        $('#signinModal').modal('hide');

        setTimeout(function () {
            $('.createaccount-modal')[0].click();
        }, 400);
    });
}

/**
 * Fills in the modal for Sign In
 */
function fillSignInModalElement(selectedValueUrl) {
    var $modal = $('#signinModal');
    $('.modal-content').spinner().start();
    $.when($.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'html',
        data: {'modal': 'true'},
        success: function (data) {
            $modal.find('.modal-body').html(data);
            $modal.modal('show');
            $modal.find('input:visible:first').focus();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    })).then(function () {
        submitCartSignIn();
        submitResetPassword();
        selectCreateAccount();
    });
}

function submitCartCreateAccount() {
    $('.create-account-submit').off().on('click', function(e) {
        e.preventDefault();
        $.spinner().start();
        var form = $(this).parents('form.registration');
        var url = form.attr('action');
        var FormValid = true;
        var anyInvalidAttribute = false;

        $(form).find('.form-control.is-invalid').removeClass('is-invalid');
        if (!form[0].checkValidity()) {
            clientSideValidation.invalid(form, event);
            $(form).find('input, select').each(function() {
                if (!this.validity.valid) {
                    $(this).trigger('invalid', this.validity);
                    $(this).addClass('is-invalid');
                    anyInvalidAttribute = true;
                    FormValid = false;
                }
            });
        } else {
            $(form).find(".js-check-sc").each(function() {
                $(this).val($(this).val().trim()); //Trim the value first
                var str = $(this).val();
                if (/^[a-zA-Z0-9-,.&*#!@()? ]*$/.test(str) == false) {
                    $(this).addClass('alt-error is-invalid');
                    // $(this)[0].setCustomValidity('invalid characters');
                    FormValid = false;
                }
            });
        }

        if (!FormValid || anyInvalidAttribute) {
            $.spinner().stop();
            return false;
        }

        form.trigger('login:register', e);
        if ($('#g-recaptcha-response').length > 0 && $('#g-recaptcha-response').attr('data-google-recaptcha-site-key') !== '') {
            var isRecaptcha = true;
            grecaptcha.ready(function() {
                var googleRecaptchaSiteKey = $('#g-recaptcha-response').attr('data-google-recaptcha-site-key');
                var token = grecaptcha.execute(googleRecaptchaSiteKey, {
                    action: 'submit'
                }).then(function(token) {
                    if ($("#createaccountModal").length > 0 && $("#createaccountModal").hasClass("show")) {
                      $("#createaccountModal #g-recaptcha-response").val(token);
                    } else {
                      $("#g-recaptcha-response").val(token);
                    }
                    createAccountAjaxCall(url, form, isRecaptcha);
                });
            });
        } else {
            createAccountAjaxCall(url, form, false);
        }
    });
}

function submitFirstTimeResetForm() {
    $('#submitEmailButton').on('click', function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');
        var url = $form.attr('action');

        $.ajax({
            url: url,
            method: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (!data.success) {
                    formValidation($form, data);
                    $.spinner().stop();
                } else {
                    $('.password-reset-migration h1').text(data.receivedMsgHeading);
                    $('.request-password-body').empty()
                        .append('<p>' + data.receivedMsgBody + '</p>');
                    $('.send-email-btn').remove();
                    $('.password-reset-migration .content-asset').remove();
                    $.spinner().stop();
                }
            },
            error: function () {
                $.spinner().stop();
            }
        })
    });
}

function getAcctFirstTimeReset(url) {
    if (url) {
        $.ajax({
            url: url + '&template=formOnly',
            method: 'get',
            dataType: 'html',
            success: function (data) {
                var modalBody = $('#signinModal .modal-body');
                modalBody.empty();
                modalBody.append(data);
                submitFirstTimeResetForm();

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        $.spinner().stop();
    }

}

function submitCartSignIn() {
    $('.login-submit').off().on('click', function (e) {
        e.preventDefault();
        var amazonPayUrl = $(this).data('url');
        var $form = $(this).parents('form.login');
        var url = $form.attr('action');
        var FormValid = true;
        $form.spinner().start();
        $form.find('.form-control.is-invalid').removeClass('is-invalid');
        if (!$form[0].checkValidity()) {
            clientSideValidation.invalid($form, event);
            $form.find('input, select').each(function () {
                if (!this.validity.valid) {
                    $(this).trigger('invalid', this.validity);
                    $(this).addClass('is-invalid');
                    FormValid = false;
                }
            });
        }

        if(!FormValid) {
            $form.spinner().stop();
            return false;
        }

        $form.trigger('login:submit', e);
        $.ajax({
            url: url,
            method: 'POST',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                } else if (data.acctFirstTimeReset && data.redirectUrl) {
                    // if first time login from account migration
                    getAcctFirstTimeReset(data.redirectUrl);
                } else {
                    klaviyoIdentify.klaviyoIdentify(url);

                    // successful login
                    if ($('.payment-details .amazon-pay-option').length) {
                        removeAmazonPay(amazonPayUrl);
                        amazon.Pay.signout();
                    }
                    if($('.login-page').length || ($('.page').data('action') === 'Order-Confirm') || ($('.page').data('action') === 'Account-PasswordReset')) {
                        setTimeout(function() {
                            $.spinner().start();
                            var location = $('.myAccount-js a').attr('href');
                            window.location = location;
                        }, 0);
                    } else if ($('.product-detail').length > 0 && $('.page').data('action') !== 'Cart-GetProduct') {
                        window.location = $('.product-details-link').attr('value');
                    } else if ($('.product-detail').length > 0 && $('.page').data('action') === 'Cart-GetProduct') {
                        var currentUrl = window.location.href;
                        var currentVariantID = currentUrl && currentUrl.indexOf('pid=') > -1 ? currentUrl.split('pid=')[1] : '';
                        var updatedVariantID = $(document).find('.product-id').html();

                        if (currentVariantID && updatedVariantID && currentVariantID !== updatedVariantID) {
                            window.location = currentUrl.indexOf(currentVariantID) > -1 ? currentUrl.replace(currentVariantID, updatedVariantID) : currentUrl;
                        } else {
                            window.location = currentUrl;
                        }
                    } else {
                        location.reload();
                    }
                }
            },
            error: function () {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $form.trigger('login:error', data);
                    $form.spinner().stop();
                }
            }
        })
    });
}

function removeAmazonPay(url) {
    $.spinner().start();

    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function submitResetPassword() {
    $('#signinModal .reset-password-link').on('click', function () {
        var url = $(this).data('url');
        var emailField = $('#signinModal #login-form-email');
        var $form = $('#signinModal .login');

        // Check email field has value
        if (emailField.val().length === 0) {
            var msg = {
                error: ['Please enter an email address.']
            };
            formValidation($form, msg);
            emailField.focus();
        } else {
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (data.success) {
                        $('.reset-password').html(data.receivedMsgBody);
                    } else {
                        formValidation($form, data);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    var msg = {
                        error: ['For technical reasons, your request could not be handled properly at this time. We apologize for any inconvenience.']
                    };
                    formValidation($form, msg);
                    $.spinner().stop();
                }
            })
        }
    });
}

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement(modalID) {
    if ($('#' + modalID).length !== 0) {
        $('#' + modalID).modal('hide');
    }
    var htmlString = '<!-- Modal -->' +
        '<div class="modal fade" id="' + modalID + '" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<button type="button" class="close pull-right" data-dismiss="modal" aria-label="close">' +
        '<span aria-hidden="true">&times;</span>' +
        '<span class="sr-only"> </span>' +
        '</button>' +
        '<div class="modal-body"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Fills in the modal for Create an Account
 */
function fillCreateAccountModalElement(selectedValueUrl) {
    var $modal = $('#createaccountModal');
    $('.modal-content').spinner().start();
    $.when($.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'html',
        data: {'modal': 'true'},
        success: function (data) {
            $modal.find('.modal-body').html(data);
            $modal.modal('show');
            $modal.find('input:visible:first').focus();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    })).then(function () {
        submitCartCreateAccount();
        selectSignIn();
        if ($(".grecaptcha-badge").length > 0) {
            $(".grecaptcha-badge").css("visibility", "unset");
        }
    });
}

/**
 * hit the Ajax call for createAccount 
 */

function createAccountAjaxCall (url, form, isRecaptcha) {

    $.ajax({
        url: url,
        method: 'POST',
        dataType: 'json',
        data: form.serialize(),
        success: function(data) {
            if (!data.success) {
                formValidation(form, data);
            } else {
                if ($("#createaccountModal").length > 0 && $("#createaccountModal").hasClass("show")) {
                    $('.create-account-submit').prop('disabled', true);
                  }
                klaviyoIdentify.klaviyoIdentify(url);
                // successful login
                if ($('.login-page').length || ($('.page').data('action') === 'Order-Confirm')) {
                    setTimeout(function() {
                        $.spinner().start();
                        var location = $('.myAccount-js a').attr('href');
                        window.location = location;
                    }, 0);
                } else if ($('.product-detail').length > 0 && $('.page').data('action') !== 'Cart-GetProduct') {
                    window.location = $('.product-details-link').attr('value');
                } else if ($('.product-detail').length > 0 && $('.page').data('action') === 'Cart-GetProduct') {
                    var currentUrl = window.location.href;
                    var currentVariantID = currentUrl && currentUrl.indexOf('pid=') > -1 ? currentUrl.split('pid=')[1] : '';
                    var updatedVariantID = $(document).find('.product-id').html();

                    if (currentVariantID && updatedVariantID && currentVariantID !== updatedVariantID) {
                        window.location = currentUrl.indexOf(currentVariantID) > -1 ? currentUrl.replace(currentVariantID, updatedVariantID) : currentUrl;
                    } else {
                        window.location = currentUrl;
                    }
                } else {
                    location.reload();
                }
            }
            $.spinner().stop();
        },
        error: function(data) {

            if (isRecaptcha && data.responseJSON.googleRecaptchaResponseError) {

                if ($('form.registration div').hasClass('alert-danger') && $('form.registration div').hasClass('alert-dismissible')) {
                    $('form.registration .alert-dismissible').remove();
                }
                var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                    'fade show" role="alert">' +
                    '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                    '<span aria-hidden="true">×</span>' +
                    '</button>' + data.responseJSON.googleRecaptchaResponseError + '</div>';

                $('form.registration').prepend(errorHtml);
                if($("#createaccountModal").length > 0 && $("#createaccountModal").hasClass('show')) {
                   $("#createaccountModal").animate({ scrollTop: 0 }, 600);
                } else {
                    $('html,body').animate({ scrollTop: 0 }, 'slow');
                }

            } else if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            }
            $(form).trigger('login:error', data);
            form.spinner().stop();
        }
    })
    }

module.exports = {
    loginAccount: function () {
        submitCartCreateAccount();
        submitCartSignIn();
        $('body').on('click', '.signin-modal', function () {
            var url = $(this).data('url');

            getModalHtmlElement('signinModal');
            fillSignInModalElement(url);
        });

        $('body').on('click', '.createaccount-modal', function () {
            var url = $(this).data('url');

            getModalHtmlElement('createaccountModal');
            fillCreateAccountModalElement(url);
        });

        $(document).on("click", function (e) {
            if ($(".grecaptcha-badge").length > 0) {
                if ($(e.target).closest('#createaccountModal').hasClass('show') || ($('.tab-pane#register').length > 0 && $('.tab-pane#register').hasClass('active'))) {
                    $(".grecaptcha-badge").css("visibility", "unset");          
                } else {
                    $(".grecaptcha-badge").css("visibility", "hidden");
                }
            }            
        });

        $('body').on('keyup', '#registration-form-password', function () {
            var letter = $(".password-message .letter");
            var capital = $(".password-message .capital");
            var special = $(".password-message .special");
            var numeric = $(".password-message .number");
            var length = $(".password-message .length");

            var upperCase = new RegExp('[A-Z]');
            var lowerCase = new RegExp('[a-z]');
            var numValidation = new RegExp('[0-9]');
            var numbers = new RegExp('[$%.,|#!=+?_~(){}\\-/\\[\\]*]');
            $('.password-message').show();
            $('.password-message').addClass('visible');


            if ($(this).val().match(upperCase)) {
                capital.removeClass("invalid");
                capital.addClass("valid");
            } else {
                capital.removeClass("valid");
                capital.addClass("invalid");
            }
            if ($(this).val().match(lowerCase)) {
                letter.removeClass("invalid");
                letter.addClass("valid");
            } else {
                letter.removeClass("valid");
                letter.addClass("invalid");
            }
            if ($(this).val().match(numbers)) {
                special.removeClass("invalid");
                special.addClass("valid");
            } else {
                special.removeClass("valid");
                special.addClass("invalid");
            }
            if ($(this).val().match(numValidation)) {
                numeric.removeClass("invalid");
                numeric.addClass("valid");
            } else {
                numeric.removeClass("valid");
                numeric.addClass("invalid");
            }
            if ($(this).val().length >= 12) {
                length.removeClass("invalid");
                length.addClass("valid");
            } else {
                length.removeClass("valid");
                length.addClass("invalid");
            }

        });

        //to show/hide the password with eye icon
        $('body').on('click','.modal-body .js-toggle-password', function () {
             //$('#signinModal .reset-password-link').on('click', function () {
            var $input = $(this).siblings('input[type="password"], input[type="text"]');
            var inputType = $input.attr('type') === 'password' ? 'text' : 'password';
            $input.attr('type', inputType);

            var $icon = $(this).find('i');
            if (inputType === 'password') {
                $icon.removeClass('fa-eye-slash').addClass('fa-eye');
                $(this).attr('aria-label', 'Show password').attr('title', 'Show password');
            } else {
                $icon.removeClass('fa-eye').addClass('fa-eye-slash');
                $(this).attr('aria-label', 'Hide password').attr('title', 'Hide password');
            }
        });

        $('body').on('blur', '#registration-form-password-confirm', function () {
            var pass = $("#registration-form-password").val();
            var passcon = $("#registration-form-password-confirm");

            if (passcon.val() != pass) {
                passcon[0].setCustomValidity('Password not matching');
                passcon.addClass('is-invalid not-matching');
            } else {
                passcon.removeClass('is-invalid not-matching');
            }
        });
    },

    getModalHtmlElement: function () {
        $('body').on(':getModalHtmlElement', function (e, data) {
            if (data.signinModal) {
                getModalHtmlElement(data.signinModal);
            }
        });
    },

    fillSignInModalElement: function () {
        $('body').on(':fillSignInModalElement', function (e, data) {
            if (data.signinUrl) {
                fillSignInModalElement(data.signinUrl);
            }
        });
    },

    preventUnwantedInput: function () {
        $(document).on('keyup','.modal-body #registration-form-fname, .modal-body #registration-form-lname, #firstName, #lastName', function (e) {
            $(this).val($(this).val().replace(/[^a-zA-Z ]/g, ''));
            address.methods.preventInputByRegex(e, new RegExp("^([a-zA-Z ])$"));
        });

        $(document).on('paste','.modal-body #registration-form-fname, .modal-body #registration-form-lname,  #firstName, #lastName', function (e) {
            $(this).val($(this).val().replace(/[^a-zA-Z ]/g, ''));
            address.methods.preventCharByPaste(e, /[a-zA-Z]$/);
        });

        $(document).on('blur','.modal-body #registration-form-fname, .modal-body #registration-form-lname', function (e) {
            var value = $(this).val();
            if(/^[a-zA-Z ]*$/.test(value) == false) {
                $(this).addClass('alt-error is-invalid');
            } else {
                $(this).removeClass('alt-error is-invalid');
            }
        });
    },
    
    tabFocusTrap: function () {
    	$(document).on('keydown', function(e){
    		let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    		
	    	if (!isTabPressed) {
	    		return;
	    	}
	    	
	    	if ($('.modal.show').length > 0) {
	    		var activeModal = $('.modal.show').attr('id');
		    	const  focusableElements =
		    		'button:not(:disabled), [href]:not([tabindex="-1"]), input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])';
		    	const modal = document.querySelector('#' + activeModal); // select the modal by it's id
		
		    	const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
		    	const focusableContent = modal.querySelectorAll(focusableElements);
		    	const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
				if (e.shiftKey) { // if shift key pressed for shift + tab combination
					if (document.activeElement === firstFocusableElement) {
						lastFocusableElement.focus(); // add focus for the last focusable element
						e.preventDefault();
					}
				} else { // if tab key is pressed
					if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
						firstFocusableElement.focus(); // add focus for the first focusable element
						e.preventDefault();
					}
				}
	    	}
    	});
    }
}